export * from './svgs/Merify-irma'
export * from './svgs/Merify-irma-404'
export * from './svgs/Merify-irma-405'
export * from './svgs/Merify-irma-anon'
export * from './svgs/Merify-irma-badge'
export * from './svgs/Merify-irma-down'
export * from './svgs/Merify-irma-dynamic-resume'
export * from './svgs/Merify-irma-head'
export * from './svgs/Merify-irma-head-error'
export * from './svgs/Merify-irma-jobs'
export * from './svgs/Merify-irma-work'
export * from './svgs/Merify-irma-question'
export * from './svgs/Merify-irma-reviews'
export * from './svgs/Merify-irma-skills'
export * from './svgs/Merify-irma-welcome.badge'
export * from './svgs/Merify-irma-welcome.work'
export * from './svgs/Merify-irma-welcome.jobs'
export * from './svgs/Merify-irma-welcome.profile'
export * from './svgs/Merify-irma-welcome.resume'
export * from './svgs/Merify-irma-welcome.reviews'
export * from './svgs/Merify-irma-welcome.skills'
export * from './svgs/Merify-resume'
export * from './svgs/Merify-resume.solid'
export * from './svgs/Merify-Vetting.guide'
export * from './svgs/Merify.m'
export * from './svgs/Merify.m.cropped'
export * from './svgs/Merify.m.mark'
export * from './svgs/Merify.word.mark'
export * from './svgs/Merify.word.mark.beta'
export * from './svgs/Merify.word.mark.r'
export * from './svgs/Merify.match.word.mark.beta'
